// FollowUpAppointment.tsx
import React from 'react';
import {
  Box, Typography, TextField, MenuItem, Button
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const FollowUpAppointment = () => (
  <Box p={2}>
    <Button startIcon={<ArrowBackIcon />} sx={{ color: 'green', mb: 2 }}>
      Follow-Up Appointment
    </Button>

    {/* Date & Time */}
    <Box mb={2} sx={{ bgcolor: '#A6FB81', display: 'inline-block', px: 2, py: 1, borderRadius: '20px' }}>
      <Typography fontWeight="bold">April 18, 2025 | 12.30pm</Typography>
    </Box>

    {/* Fields */}
    <Box mb={2}>
      <Typography>Purpose of Visit</Typography>
      <TextField fullWidth variant="outlined" />
    </Box>
    <Box mb={2}>
      <Typography>Location</Typography>
      <TextField fullWidth select value="Online">
        <MenuItem value="Online">Online</MenuItem>
        <MenuItem value="Clinic">Clinic</MenuItem>
      </TextField>
    </Box>
    <Box mb={2}>
      <Typography>Additional Note</Typography>
      <TextField fullWidth multiline rows={5} />
    </Box>
  </Box>
);

export default FollowUpAppointment;
